import { ref } from 'vue'

const isLoading = ref(false)

export function useSlideLoader() {
  const setLoadingState = loadingState => {
    isLoading.value = loadingState
  }

  return {
    isLoading,
    setLoadingState,
  }
}
